/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      if (process.env.VUE_APP_SERVICE_WORKER_LOG === 'true') {
        console.log(
          'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB',
        );
      }
    },
    registered(registration) {
      if (process.env.VUE_APP_SERVICE_WORKER_LOG === 'true') {
        console.log('Service worker has been registered.', registration);
      }
      setInterval(() => {
        if (process.env.VUE_APP_SERVICE_WORKER_LOG === 'true') {
          console.log('Checking for updates...');
        }
        registration.update();
      }, 1000 * 60 * 60); // e.g. hourly checks
    },
    cached() {
      if (process.env.VUE_APP_SERVICE_WORKER_LOG === 'true') {
        console.log('Content has been cached for offline use.');
      }
    },
    updatefound() {
      if (process.env.VUE_APP_SERVICE_WORKER_LOG === 'true') {
        console.log('New content is downloading.');
      }
    },
    updated(registration) {
      if (process.env.VUE_APP_SERVICE_WORKER_LOG === 'true') {
        console.log('New content is available; please refresh.', registration);
      }
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: { sw: registration.waiting } }),
      );
    },
    offline() {
      if (process.env.VUE_APP_SERVICE_WORKER_LOG === 'true') {
        console.log('No internet connection found. App is running in offline mode.');
      }
    },
    error(error) {
      if (process.env.VUE_APP_SERVICE_WORKER_LOG === 'true') {
        console.error('Error during service worker registration:', error);
      }
    },
  });
}
